interface CaptureServiceInitEvent {
  orderId: any;
}

type EventType = "start" | "change" | "clear" | "stepChange";

const events = {
  start: "captureServicePreorder.start",
  change: "captureServicePreorder.change",
  clear: "captureServicePreorder.clear",
  stepChange: "captureServicePreorder.stepChange",
};
const funcs = {};

function broadcast(eventType: EventType, data?: any): void {
  let event: CustomEvent;
  if (eventType === "start") {
    const orderId = data;
    event = new CustomEvent<CaptureServiceInitEvent>(events.start, {
      detail: {
        orderId,
      },
    });
  } else {
    event = new CustomEvent(
      events[eventType],
      data ? { detail: { ...data } } : null
    );
  }
  document.dispatchEvent(event);
}

function listen(eventType: EventType, callback: (e: CustomEvent) => void) {
  funcs[eventType] = callback;
  document.addEventListener(events[eventType], callback);
}

function remove(eventType: EventType) {
  document.removeEventListener(events[eventType], funcs[eventType]);
}

export default {
  broadcast,
  listen,
  remove,
};
